export default "__VITE_ASSET__BHZtNZnT__"